import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.a7j_1 = prereleaseMode;
        this.b7j_1 = auth0ClientId;
        this.c7j_1 = auth0Domain;
        this.d7j_1 = basename;
        this.e7j_1 = expressEnv;
        this.f7j_1 = webpackPublicPath;
        this.g7j_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.a7j_1 + ', auth0ClientId=' + this.b7j_1 + ', auth0Domain=' + this.c7j_1 + ', basename=' + this.d7j_1 + ', expressEnv=' + this.e7j_1 + ', webpackPublicPath=' + this.f7j_1 + ', websocketHost=' + this.g7j_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.a7j_1);
        result = imul(result, 31) + getStringHashCode(this.b7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.d7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f7j_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g7j_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.a7j_1 === other.a7j_1))
          return false;
        if (!(this.b7j_1 === other.b7j_1))
          return false;
        if (!(this.c7j_1 === other.c7j_1))
          return false;
        if (!(this.d7j_1 === other.d7j_1))
          return false;
        if (!(this.e7j_1 === other.e7j_1))
          return false;
        if (!(this.f7j_1 === other.f7j_1))
          return false;
        if (!(this.g7j_1 === other.g7j_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
